<template>
  <b-modal
    :id="id"
    :size="size"
    hide-header
    hide-footer
    centered
    :no-close-on-backdrop="!closeOnBackdrop"
    body-class="m-3 text-primary"
  >

    <div  id="content">
      <slot name="title"></slot>
      <slot name="content"></slot>
      <slot name="button"></slot>

    </div>
    <!--<div v-if="isLoading" id="loading" class="text-center">
      <h3 class="text-center mb-5">{{$t($getConst.pages.scope.please_wait) | capitalize}} ...</h3>
      <b-spinner variant="secondary" label="Spinning"></b-spinner>
    </div>-->
  </b-modal>
</template>

<script>
  export default {
    name: "AppModal",
    props: {
      id: {
        String,
        required: true
      },
      size: {
        String,
        default: "md"
      },
      closeOnBackdrop: {
        type: Boolean,
        default: false
      },
      isLoading: Boolean
    },
  }
</script>

<style scoped>

</style>
